export enum TShirtSize {
	Xs = "Xs",
	S = "S",
	M = "M",
	L = "L",
	Xl = "Xl",
	Xxl = "Xxl",
	Xxxl = "Xxxl",
}
